export default "__VITE_ASSET__De7$woG5__"